import React from 'react';

const FormCardGroup = function (props) {
  const {
    text, children, name, required
  } = props;
  const headName = `head_${name}`;
  return (
    <div role="group" className="formElement type-card">
      {text && <span id={headName}>{required && (<span className="required">*</span>)}{text}</span>}
      <div>
        { children }
      </div>
    </div>
  );
};

export default FormCardGroup;



// WEBPACK FOOTER //
// ./src/pages/Helpers/Form/FormCardGroup.js